import { render, staticRenderFns } from "./NavigationDrawer.vue?vue&type=template&id=f271ea56&scoped=true&"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js&"
import style0 from "./NavigationDrawer.vue?vue&type=style&index=0&id=f271ea56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f271ea56",
  null
  
)

export default component.exports